App.factory('insuranceService', ['$q', 'baseService', 'Config', function($q, baseService, Config) {
    function InsuranceService() {
        this.dataList = function(data) {
            return baseService.post(Config.API_URL + '/insuranceDeclaration/list', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.last = function() {
            return baseService.get(Config.API_URL + '/insuranceDeclaration/last').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.add = function(data) {
            return baseService.post(Config.API_URL + '/insuranceDeclaration/save', data).then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getStatement = function(uuid) {
            return baseService.download(Config.API_URL + '/insuranceDeclaration/' + uuid + '/statement').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };

        this.getDeclaration = function(uuid) {
            return baseService.download(Config.API_URL + '/insuranceDeclaration/' + uuid + '/declaration').then(function(success) {
                return success;
            }, function(error) {
                return error;
            });
        };
        
    }
    return new InsuranceService();
}]);
